package br.com.texeratx.boardgametimeapp.ui.screens.matches.edit

data class EditablePlayerScoreUI(
    val playerId: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val points: String
)
